export enum AlertTypesEnum {
  Success = 'success',
  Error = 'danger',
  Info = 'primary',
  Warning = 'warning'
}
